import QuoteRoutes from '../route-types'

export default {
  inject: ['$vv'],
  computed: {
    $v() {
      return this.$vv || this.$v
    },
    validationItems() {
      // Only the legacy Other Labour tab still resolves here. The Quote Builder route
      // was never in this switch - its item components rely on the undefined-safe
      // guards in isValidItemNo/isValidItemDesc below.
      if (this.$route.name === QuoteRoutes.QuoteOtherLabour.name) {
        return this.$v.entity.others
      }
      return undefined
    }
  },
  methods: {
    isValidItemNo(quoteItemId) {
      if (this.validationItems) {
        const index = this.validationItems.$model.findIndex(i => i.quoteItemId === quoteItemId)
        if (this.validationItems.$each[index]) {
          return this.validationItems.$each[index].itemNo.required
        } else {
          return false
        }
      }
    },
    isValidItemDesc(quoteItemId) {
      if (this.validationItems) {
        const index = this.validationItems.$model.findIndex(i => i.quoteItemId === quoteItemId)
        if (this.validationItems.$each[index]) {
          return this.validationItems.$each[index].itemDesc.required
        } else {
          return false
        }
      }
    }
  }
}
